export const socialLinkTemplate = {
    type: 'Example: "facebook"',
    link: 'http://example.com',
    title_en: 'Title',
    title_ukr: 'Назва'
}
